var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroEmoji2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 76,
    viewBox: "0 0 72 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_66_1939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 36C71 55.33 55.33 71 36 71C16.67 71 1 55.33 1 36C1 16.67 16.67 1 36 1C55.33 1 71 16.67 71 36Z",
    fill: "#FFE7DD",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0291 52.123C44.969 52.1564 44.9156 52.1832 44.8555 52.2099C44.9156 52.1832 44.969 52.1498 45.0291 52.123Z",
    fill: "#FF4E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2448 34.0029C30.0892 34.0029 31.5843 29.8404 31.5843 24.7057C31.5843 19.571 30.0892 15.4084 28.2448 15.4084C26.4004 15.4084 24.9053 19.571 24.9053 24.7057C24.9053 29.8404 26.4004 34.0029 28.2448 34.0029Z",
    fill: "#FF4E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9743 34.0029C45.8187 34.0029 47.3138 29.8404 47.3138 24.7057C47.3138 19.571 45.8187 15.4084 43.9743 15.4084C42.1299 15.4084 40.6348 19.571 40.6348 24.7057C40.6348 29.8404 42.1299 34.0029 43.9743 34.0029Z",
    fill: "#FF4E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8496 52.2099C44.9097 52.1832 44.9631 52.1564 45.0233 52.123C44.9631 52.1498 44.9097 52.1765 44.8496 52.2099Z",
    fill: "#FF4E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0299 50.3865L51.221 44.3486C50.8069 43.8343 50.0521 43.7475 49.5379 44.1616C49.0236 44.5757 48.9367 45.3237 49.3508 45.8447L50.8536 47.7282C49.785 48.897 48.6028 49.9256 47.3137 50.7939V47.5479C47.3137 46.546 46.9063 45.631 46.2451 44.9764C45.5906 44.3219 44.6755 43.9078 43.6737 43.9078C41.6766 43.9078 40.0469 45.5174 40.0336 47.5211C40.0336 48.3026 40.0136 49.2109 39.9868 50.2529C39.9401 52.3033 38.8714 53.4789 37.7694 54.1401C37.2418 54.1868 36.7141 54.2069 36.1798 54.2069C30.4492 54.2069 25.0859 51.7757 21.3123 47.5078L22.6414 45.8514C23.0555 45.3371 22.9687 44.5824 22.4544 44.1683C21.9401 43.7542 21.1854 43.841 20.7713 44.3553L15.9624 50.3931C15.5483 50.9074 15.6351 51.6621 16.1494 52.0762C16.3698 52.2499 16.6369 52.3367 16.8974 52.3367C17.2447 52.3367 17.5987 52.1831 17.8325 51.8892L19.8095 49.4113C24.0239 53.9998 29.9082 56.6046 36.1865 56.6046C42.4648 56.6046 48.162 54.08 52.3631 49.625L54.1664 51.8892C54.4002 52.1831 54.7475 52.3367 55.1015 52.3367C55.362 52.3367 55.6225 52.2499 55.8496 52.0762C56.3638 51.6621 56.4507 50.9074 56.0366 50.3931L56.0299 50.3865ZM41.5631 53.1716C41.9638 52.6172 42.3312 52.0028 42.3312 50.4532V47.6414C42.3312 46.9 42.939 46.2922 43.6804 46.2922C44.0544 46.2922 44.3883 46.4458 44.6355 46.6863C44.8759 46.9334 45.0295 47.2673 45.0295 47.6414V52.123C44.9694 52.1497 44.916 52.1831 44.8559 52.2098C44.7957 52.2366 44.7356 52.2699 44.6822 52.2967C44.5286 52.3701 44.375 52.4369 44.2147 52.5104C44.0544 52.5839 43.9007 52.6507 43.7471 52.7108C43.5868 52.7776 43.4332 52.8377 43.2729 52.8978C43.1794 52.9378 43.0792 52.9712 42.979 53.0113C42.8989 53.038 42.8187 53.0714 42.7319 53.0981C42.5917 53.1449 42.4447 53.1983 42.2978 53.2451C42.2243 53.2718 42.1508 53.2918 42.0841 53.3119C42.0173 53.3319 41.9571 53.3519 41.8904 53.372C41.69 53.4321 41.4963 53.4855 41.2959 53.539C41.3894 53.4254 41.4829 53.3052 41.5831 53.1783L41.5631 53.1716Z",
    fill: "#FF4E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0291 52.123C44.969 52.1564 44.9156 52.1832 44.8555 52.2099C44.9156 52.1832 44.969 52.1498 45.0291 52.123Z",
    fill: "#FF4E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_66_1939",
    x: 0,
    y: 0,
    width: 72,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_66_1939"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_66_1939",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroEmoji2);
export default __webpack_public_path__ + "static/media/hero-emoji2.0bf186847b478f86877e1c269e63f017.svg";
export { ForwardRef as ReactComponent };